import { Pill } from "@/components/atoms/Pill/Pill";
import CheckboxGroup, { type CheckboxGroupItem } from "@/components/molecules/CheckboxGroup/CheckboxGroup";
import { DropdownMenu } from "@/components/molecules/DropdownMenu/DropdownMenu";
import { Tag } from "@/components/molecules/Tag/Tag";
import { TagGroup } from "@/components/molecules/TagGroup/TagGroup";
import { TooltipWrapper } from "@/components/molecules/TooltipWrapper/TooltipWrapper";
import { t } from "@lingui/core/macro";
import { useRef, useState } from "react";
import "./DashboardCardTagGroup.scss";

type DashboardCardTagGroupProps = {
  onSetTags?: (tags: string[]) => void;
  capacity?: number;
  items: CheckboxGroupItem[];
  tags?: string[];
};

export const DashboardCardTagGroup: React.FC<DashboardCardTagGroupProps> = ({
  onSetTags,
  items,
  tags,
  capacity = 10,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  const addTagClickHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();

    if (items.length === 0) {
      return;
    }

    setDropdownOpen(!dropdownOpen);
  };

  const handleToggleTag = (id: string | number) => {
    const existingTags = items.filter((it) => it.isChecked).map((it) => String(it.id));

    if (existingTags.includes(String(id))) {
      // Remove
      const newTags = existingTags.filter((t) => t !== String(id));
      onSetTags?.(newTags);
    } else {
      // Add
      if (existingTags.length < capacity) {
        const newTags = [...existingTags, String(id)];
        onSetTags?.(newTags);
      }
    }
  };

  return (
    <TagGroup>
      <div className="tag-group__add-container" ref={anchorRef}>
        <TooltipWrapper tooltipText={t`Add tag`} position="right" tail={true}>
          <Pill onClick={addTagClickHandler} className="add-tag tag-style">
            <span className="material-icons">tag</span>
          </Pill>
        </TooltipWrapper>
      </div>

      {tags?.map((tag) => (
        <Tag
          isSelectable={false}
          key={tag}
          label={tag}
          onClick={() => {}}
          iconName="delete"
          onIconClick={() => handleToggleTag(tag)}
        />
      ))}

      {dropdownOpen && (
        <DropdownMenu isOpen={dropdownOpen} anchorRef={anchorRef} onClose={() => setDropdownOpen(false)}>
          <CheckboxGroup items={items} onClick={handleToggleTag} />
        </DropdownMenu>
      )}
    </TagGroup>
  );
};
